import {Injectable} from '@angular/core';
import {NestApiProvider} from '../nest-api';
import {Observable} from 'rxjs';
import {ResponseData} from '../nest-responses';
import {RequestGetSocso, RequestUpdateSocso, ResponseGetSocso} from './socso-setting.dto';

@Injectable()
export class SocsoSettingApi {
  private readonly service: string = 'payroll';
  private readonly model: string = 'socso-setting';

  constructor(
      private nestApiProvider: NestApiProvider,
  ) {
  }

  public getsocso(payload: RequestGetSocso = null): Observable<ResponseData<ResponseGetSocso[]>> {
    const method: string = 'GET';
    const func: string = 'getsocso';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseGetSocso[]>>(method, url, params, urlParams, body);
  }

  public createUpdateSocso(payload: RequestUpdateSocso[]): Observable<any> {
    const method: string = 'POST';
    const func: string = 'createUpdateSocso';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/socso-setting.api.ts